function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1700,
  height: 500,
  fillOpacity: 0
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0 287.5v-218.75l187.5-68.75 187.5 68.75v218.75c0 88.35-99.608 150-187.5 212.5-87.892-62.5-187.5-124.15-187.5-212.5z",
  fill: "#2E5266"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m45 278.5v-166.25l142.5-52.25 142.5 52.25v166.25c0 67.146-75.702 114-142.5 161.5-66.798-47.5-142.5-94.354-142.5-161.5z",
  fill: "#FF5E5B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m90 269.5v-113.75l97.5-35.75 97.5 35.75v113.75c0 45.942-51.796 78-97.5 110.5-45.704-32.5-97.5-64.558-97.5-110.5z",
  fill: "#FFED66"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m135 260.5v-61.25l52.5-19.25 52.5 19.25v61.25c0 24.738-27.89 42-52.5 59.5-24.61-17.5-52.5-34.762-52.5-59.5z",
  fill: "#2D5266"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m584.35 179.74v83.092q0 33.062-21.752 49.267t-58.077 16.205q-19.794 0-35.891-5.111-16.096-5.112-25.667-13.378-19.794-17.184-19.794-36.978 0-1.957 1.414-3.371t3.371-1.414h49.159q3.916 0 5.438 4.785 4.133 13.051 20.882 13.051 10.223 0 16.205-4.785t5.982-13.704v-48.941h-79.394q-2.393 0-4.133-1.74t-1.74-4.133v-32.845q0-2.393 1.74-4.133t4.133-1.74h132.25q2.392 0 4.133 1.74 1.74 1.74 1.74 4.133z",
  fill: "#2D5266"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m775.55 236.73v26.538q0 22.404-10.876 37.413-10.876 15.008-28.495 21.316t-41.546 6.308-41.546-6.308-28.494-21.316q-10.876-15.009-10.876-37.848v-25.668q0-32.845 22.513-49.159 22.513-16.313 58.403-16.313 35.891 0 58.404 16.313 22.513 16.314 22.513 48.724zm-103.1-4.132v34.802q0 8.919 5.982 13.704t16.205 4.785q10.224 0 16.205-4.894 5.982-4.894 5.982-13.812v-34.368q0-8.918-5.982-13.812-5.981-4.894-16.205-4.894-10.223 0-16.205 4.785t-5.982 13.704z",
  fill: "#2D5266"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m962.4 278.28q0 47.854-61.34 47.854h-89.618q-2.392 0-4.132-1.74-1.741-1.74-1.741-4.133v-140.52q0-2.393 1.741-4.133 1.74-1.74 4.132-1.74h87.443q30.887 0 45.57 11.202 14.682 11.202 14.682 33.824v0.652q0 10.441-5.655 17.837-5.656 7.396-11.746 9.353 8.483 2.61 14.573 11.42 6.091 8.809 6.091 20.12zm-100.28-10.876v21.317h31.54q5.003 0 7.505-3.371 2.501-3.372 2.501-7.505v-0.217q0-4.133-2.719-7.178-2.719-3.046-7.287-3.046zm35.673-39.37q2.393-3.263 2.393-7.178 0-3.916-2.284-6.743-2.284-2.828-6.634-2.828h-29.148v19.794h29.148q4.35 0 6.525-3.045z",
  fill: "#2D5266"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m1092 173.87h44.809q2.393 0 4.133 1.74t1.74 4.133v140.52q0 2.393-1.74 4.133t-4.133 1.74h-44.809q-2.392 0-4.132-1.74-1.741-1.74-1.741-4.133v-46.331h-43.503v46.331q0 2.393-1.74 4.133t-4.133 1.74h-44.809q-2.392 0-4.133-1.631-1.74-1.632-1.74-4.242v-140.52q0-2.393 1.74-4.133 1.741-1.74 4.133-1.74h44.809q2.393 0 4.133 1.74t1.74 4.133v44.591h43.503v-44.591q0-2.393 1.741-4.133 1.74-1.74 4.132-1.74z",
  fill: "#2D5266"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m1233 283.72h86.79q2.393 0 4.133 1.74 1.74 1.741 1.74 4.133v30.67q0 2.393-1.74 4.133t-4.133 1.74h-137.47q-2.392 0-4.132-1.74-1.741-1.74-1.741-4.133v-140.52q0-2.393 1.741-4.133 1.74-1.74 4.132-1.74h135.3q2.392 0 4.132 1.74 1.741 1.74 1.741 4.133v30.67q0 2.392-1.741 4.133-1.74 1.74-4.132 1.74h-84.615v13.703h72.651q2.393 0 4.133 1.74 1.74 1.741 1.74 4.133v28.278q0 2.392-1.74 4.132-1.74 1.741-4.133 1.741h-72.651z",
  fill: "#2D5266"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m1520.5 319.39q0.435 0.87 0.435 2.393 0 1.522-1.414 2.936t-3.372 1.414h-49.376q-6.526 0-9.136-5.438l-19.142-43.068h-18.271v42.633q0 2.393-1.74 4.133t-4.133 1.74h-46.984q-2.393 0-4.133-1.74t-1.74-4.133v-140.52q0-2.393 1.74-4.133t4.133-1.74h84.615q29.799 0 47.201 14.138 17.401 14.139 17.401 38.501 0 29.582-22.839 42.851zm-100.28-105.06v23.057h27.19q4.785 0 7.395-3.154 2.611-3.154 2.611-7.939 0-4.786-2.502-8.375-2.501-3.589-7.504-3.589z",
  fill: "#2D5266"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m1700 236.73v26.538q0 22.404-10.876 37.413-10.876 15.008-28.495 21.316t-41.546 6.308-41.546-6.308-28.494-21.316q-10.876-15.009-10.876-37.848v-25.668q0-32.845 22.513-49.159 22.513-16.313 58.403-16.313 35.891 0 58.404 16.313 22.513 16.314 22.513 48.724zm-103.1-4.132v34.802q0 8.919 5.982 13.704t16.205 4.785q10.224 0 16.205-4.894 5.982-4.894 5.982-13.812v-34.368q0-8.918-5.982-13.812-5.981-4.894-16.205-4.894-10.223 0-16.205 4.785t-5.982 13.704z",
  fill: "#2D5266"
});

var SvgJobHeroLogov2 = function SvgJobHeroLogov2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1700 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobHeroLogov2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/job-hero-logov2.afe92279.svg";
export { ForwardRef as ReactComponent };